module.exports = __webpack_public_path__ + "static/media/alert.98cb30e7.webp";